$ = jQuery;

$(document).ready(function () {
	$(document).foundation();
	set_main_menu_width();
	operate_main_menu();
	display_search_screen();
	toggle_child_tabs();
	IBAN_calculator();
	pengeVirkeSlider();
	frendeWebshopAndRelated();
	remembertab();
	openRememberedTab();
	changeTabIndex();
	make_child_tabs_fit();
	mobile_tab_menu();
	scrolltotop();
	initFilterCustomPosts();
	jumbotron();
	tabindex_fix_main_menu();
	hideOnLoad();
	youtube_embed_overlap_fix();
	analytics_events();
	increase_fontsize();
	featured_slide();
	contactForm();
	formDataAttr();
	snow();
	headerNotice();
	searchBoxStyling();
	investorRelationsTabs();
	updateKundeerklering();
	// Ajax load more news variables
	var pageNum = parseInt(pbd_alp.startPage) + 1; // The number of the next page to load (/page/x/).
	var max = parseInt(pbd_alp.maxPages); // The maximum number of pages the current query can return.
	var nextLink = pbd_alp.nextLink; // The link of the next page of posts.
});

function updateKundeerklering() {
    if ($(window).width() < 768) {
        $('#kundeærklering span').text('Erklæring');
    } else {
        $('#kundeærklering span').text('Kundeerklæring');
    }
}

function hideOnLoad() {
	$(window).load(function () {
		$('.hide-on-load').fadeIn('slow'); // Kris, is this actually in use anymore?
	});
}

function jumbotron() {
	$('#intro-description').fadeIn();
	$('.jumbotron-click').mouseover(function () {
		var ID = this.id + '-title';
		$('#' + ID).show();
	});

	$('.jumbotron-click').mouseleave(function () {
		var ID = this.id + '-title';
		$('#' + ID).hide();
	});

	$('.jumbotron-click').on('click', function (e) {
		e.preventDefault();
		var id = '#' + this.id;
		var newId = '#' + this.id + '-title';
		var descrId = '#' + this.id + '-description';
		$('.jumbotron-click-title').removeClass('click-title');
		$('.jumbotron-click').removeClass('hovered');
		$(newId).addClass('click-title');
		if (this.id == 'mat') {
			if ($(descrId).is(':hidden')) {
				$(id).addClass('hovered');
				$('.jumbotron-text article').hide();
				$(descrId).fadeIn();
			} else {
				$(newId).removeClass('click-title');
				$(descrId).hide();
				$(id).removeClass('hovered');
				$('#intro-description').fadeIn();
			}
		}
		if (this.id == 'luft') {
			if ($(descrId).is(':hidden')) {
				$(id).addClass('hovered');
				$('.jumbotron-text article').hide();
				$(descrId).fadeIn();
			} else {
				$(newId).removeClass('click-title');
				$(descrId).hide();
				$(id).removeClass('hovered');
				$('#intro-description').fadeIn();
			}
		}
		if (this.id == 'kultur') {
			if ($(descrId).is(':hidden')) {
				$(id).addClass('hovered');
				$('.jumbotron-text article').hide();
				$(descrId).fadeIn();
			} else {
				$(newId).removeClass('click-title');
				$(descrId).hide();
				$(id).removeClass('hovered');
				$('#intro-description').fadeIn();
			}
		}
		if (this.id == 'felleskap') {
			if ($(descrId).is(':hidden')) {
				$(id).addClass('hovered');
				$('.jumbotron-text article').hide();
				$(descrId).fadeIn();
			} else {
				$(newId).removeClass('click-title');
				$(descrId).hide();
				$(id).removeClass('hovered');
				$('#intro-description').fadeIn();
			}
		}
	});
}

$(window).on('resize', function () {
	set_main_menu_width();
	updateKundeerklering();
});

function mobile_tab_menu() {
	var newText = $('#tab-meny-wrapper').find($('.child-tab-link.active')).text();

	if ($(window).width() < 1024) {
		//$('#tab-meny-wrapper ul').hide();

		$('#responsive-menu').text(newText);

		$('#tab-meny-wrapper').on('click', function () {
			$(this).find('ul').fadeToggle();
		});

		$('#tab-meny-wrapper ul li a').on('click', function (e) {
			newText = $(this).text();

			$('#responsive-menu').text(newText);
			//$('#tab-meny-wrapper ul').fadeToggle();

			e.stopPropagation();
		});
	}

	/*$(window).resize(function() {
		if ($(window).width() > 1024) {
			$('#tab-meny-wrapper ul').show();
		}

		if ($(window).width() < 1024) {
			$('#tab-meny-wrapper ul').hide();
		}
	});*/
}

function scrolltotop(target) {
	$('.sr-only').on('click', function (e) {
		// var target = $(this).attr('href');
		// console.log('scrolling');
		// e.preventDefault();
		// scroll_there(target);
	});
}

function scroll_there(hash) {
	var $select_item = $(hash);
	if ($select_item.length > 0) {
		$('html, body').animate(
			{
				scrollTop: $select_item.offset().top,
			},
			800
		);
	}
}

function changeTabIndex() {
	$('.sr-only').on('click', function (e) {
		var element = document.getElementById('main');

		if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
			element.tabIndex = -1;
		}

		e.preventDefault();

		$('html, body').animate(
			{
				scrollTop: $(element).offset().top,
			},
			800,
			function () {
				element.focus();
			}
		);
	});
	// window.addEventListener("hashchange", function(event) {
	//    var element = document.getElementById(location.hash.substring(1));
	//    if (element) {
	//        if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
	//            element.tabIndex = -1;
	//        }
	//        element.focus();
	//    }
	// }, false);
}

function pengeVirkeSlider() {
	$sliderWrap = $('#pengevirke-slider');
	$slider = $('#pengevirke-owl');
	$owl = $slider.owlCarousel({
		rewindNav: false,
		afterAction: function () {
			if (this.itemsAmount > this.visibleItems.length) {
				$('.next', $sliderWrap).show();
				$('.prev', $sliderWrap).show();

				$('.next', $sliderWrap).removeClass('disabled');
				$('.prev', $sliderWrap).removeClass('disabled');
				if (this.currentItem == 0) {
					$('.prev', $sliderWrap).addClass('disabled');
				}
				if (this.currentItem == this.maximumItem) {
					$('.next', $sliderWrap).addClass('disabled');
				}
			} else {
				$('.next', $sliderWrap).hide();
				$('.prev', $sliderWrap).hide();
			}
		},
	});

	$('#toggle-pengevirkeslider').on('click', function () {
		$sliderWrap.slideToggle(150);
		$activeIndex = $slider.find('.item.active').index('.item', $slider);
		$slider.trigger('owl.goTo', $activeIndex);

		// Center active item
		var slideToCenter = $slider.find('.item.active').parent().index();
		var noOfSlides = $slider.find('.owl-item').length;
		if (slideToCenter < noOfSlides - 4) {
			$owl.trigger('owl.prev');
			$owl.trigger('owl.prev');
		} else if (slideToCenter < noOfSlides - 3) {
			$owl.trigger('owl.prev');
		}
	});

	$sliderWrap.find('.next').click(function () {
		$owl.trigger('owl.next');
	});
	$sliderWrap.find('.prev').click(function () {
		$owl.trigger('owl.prev');
	});
}

function tabindex_fix_main_menu() {
	$('#main-menu a').each(function () {
		$(this).attr('tabindex', '-1');
	});
}

function operate_main_menu() {
	$('#menu-toggle-open').on('click', function (e) {
		e.preventDefault();
		$('#main-menu, #mask').toggleClass('active');
		$('#main-menu a').each(function () {
			$(this).removeAttr('tabindex');
			$('#main-menu a:first').attr('tabindex', '0');
			$('#english-toggle').focus();
		});
	});

	$('#mask, #menu-toggle-close').on('click', function (e) {
		e.preventDefault();
		$('#main-menu, #mask').removeClass('active');
		$('#main-menu a').each(function () {
			$(this).attr('tabindex', '-1');
		});
	});

	var $mainMenu = $('#main-menu');

	$mainMenu.find('.menu-item-has-children > a').on('click', function (e) {
		e.preventDefault();
		var theLi = $(this).parent('li');
		$mainMenu.find('ul.sub-menu li').not(theLi).fadeOut(100);
		$mainMenu
			.find('ul.sub-menu')
			.not(theLi.find('.sub-menu'))
			.slideUp(200, function () {
				$(this).parent('li').removeClass('current-menu-item');
			});

		if (theLi.hasClass('current-menu-item')) {
			theLi.find('ul.sub-menu').slideUp(200, function () {
				theLi.removeClass('current-menu-item');
			});
		} else {
			theLi.find('ul.sub-menu').slideDown(200, function () {
				theLi.addClass('current-menu-item');
			});
		}
		theLi.find('ul.sub-menu li').fadeToggle(400);
	});

	$mainMenu.find('ul.sub-menu li a').on('click', function (e) {
		e.stopPropagation();
	});
}

function set_main_menu_width() {
	var menu_opener_position = $('header #menu-toggle-open').position();
	var menu_width = $(window).width() - menu_opener_position.left + 97;
	menu_width = menu_width < 300 ? $(document).width() : menu_width;
	$('#main-menu').css({
		width: menu_width + 'px',
		right: '-' + menu_width + 'px',
	});
}

function display_search_screen() {
	$('#search-toggle-open, #search-toggle-menu').on('click', function (e) {
		e.stopPropagation();
		e.preventDefault();

		$('#search-overlay').fadeToggle().toggleClass('active');
		$('html').toggleClass('overflow-hidden');
		document.body.classList.remove('search-results-light'); // Make sure the search results box is dark themed

		if ($('#search-overlay').hasClass('active'))
			$('#search-overlay').find('input[type="search"]').get(0).focus();
	});

	$('#search-toggle-close').on('click', function (e) {
		e.preventDefault();
		$('#search-overlay').fadeOut().removeClass('active');
		$('html').removeClass('overflow-hidden');
	});

	$('.search-wrapper, .searchwp-live-search-results').on('click', function (e) {
		e.stopPropagation();
	});

	$('body').on('click', function () {
		$('#search-overlay').fadeOut().removeClass('active');
		$('html').removeClass('overflow-hidden');
	});
}

function toggle_child_tabs() {
	// $('article.child-tabs-content .child-tab:nth-of-type(1)').show();
	$('.tabbed-nav li:first-of-type .child-tab-link').addClass('active');

	$('.child-tab-link').on('click', function (e) {
		e.preventDefault();
		var child_target = $(this).attr('href');

		//reset things
		$('.child-tab-link').removeClass('active');
		$('.child-tab').hide();

		//do ALL the things
		$(this).addClass('active');
		$(child_target).fadeIn();
	});
}

function make_child_tabs_fit() {
	var accu_length = 0;
	var limitTries = 1;
	calc_size();

	$(window).on('resize', function () {
		calc_size();
	});

	function calc_size() {
		accu_length = 0;
		$('#tab-meny-wrapper li').each(function () {
			accu_length += $(this).width();
		});
		setTimeout(function () {
			resize_font();
		}, 50);
	}

	function resize_font() {
		// console.log(accu_length);
		if ($(document).width() > 1024) {
			if (accu_length > $('#tab-meny-wrapper').width()) {
				curSize = parseInt($('.child-tab-link').css('font-size'));
				newSize = curSize - limitTries;

				// console.log('current: ' + curSize + 'new: ' + newSize);
				$('.child-tab-link').css('font-size', newSize);

				if (limitTries < 30) {
					limitTries++;
					setTimeout(function () {
						calc_size();
					}, 50);
				}
			}
		}
	}
}

function IBAN_calculator() {
	// Code for the IBAN calculator is in sections/content-iban.php

	$('#acc1').on('keypress', function (e) {
		if (e.keyCode == 13) {
			Next();
		}
	});
}

function initFilterCustomPosts() {
	$filters = $('#cat-filters');
	if ($filters.length <= 0) return;

	// INITIAL RUN! Ready, set..
	dc_get_posts($filters, false);

	$filters.find('input').on('change', function () {
		if ($(this).attr('name') == 'alle') {
			$filters.find('input').removeAttr('checked');
			$(this).attr('checked', 'checked');
			$(this).addClass('checked');
		} else if ($filters.find('input#alle.checked').length) {
			$filters.find('input#alle.checked').removeAttr('checked');
			$filters.find('input#alle.checked').removeClass('checked');
		} else if ($filters.find('input:checked').length <= 0) {
			$filters.find('input#alle').attr('checked', 'checked');
			$filters.find('input#alle').addClass('checked');
		}

		dc_get_posts($filters, false);

		categories = getFiltersAsArray().toString();
		categories = categories.replace(/,/g, '+');
		window.history.replaceState(
			{},
			document.title,
			document.location.pathname + '?filter=' + categories
		);
	});

	$('#ajax-content-wrap .loadmore').on('click', function () {
		var append = true;
		dc_get_posts($filters, true);
	});

	// get categories
	function getFiltersAsArray() {
		var categories = [];
		if ($filters.find('input#alle.checked')) {
			categories.push($filters.find('input#alle.checked').attr('name'));
		}
		$filters.find('input:checked').each(function () {
			if ($(this).attr('name') !== 'alle') {
				categories.push($(this).attr('name'));
			}
		});
		return categories;
	}

	function dc_get_posts($filters, append) {
		var args = {
			post_type: $filters.data('posttype'),
			page_number: $filters.attr('data-page'),
			result_wrapper: '#ajax-content-wrap',
			categorytax: $filters.data('categorytax'),
			append: append,
		};

		if (args.append == false) args.page_number = 1;

		var categories = [];
		if ($filters.find('input#alle.checked')) {
			categories.push($filters.find('input#alle.checked').attr('name'));
		}
		$filters.find('input:checked').each(function () {
			if ($(this).attr('name') !== 'alle') {
				categories.push($(this).attr('name'));
			}
		});

		var result_wrapper = args.result_wrapper,
			append = args.append;

		var mydata = {
			action: 'dc_get_posts',
			categorytax: args.categorytax,
			categories: categories,
			page_number: args.page_number,
			post_type: args.post_type,
		};

		$.ajax({
			type: 'POST',
			url: ajaxurl,
			dataType: 'html',
			data: mydata,
			beforeSend: function () {
				$('.ajax-loader', result_wrapper).addClass('active');
			},
			error: function () {
				$('.ajax-loader', result_wrapper).removeClass('active');
				$(result_wrapper).html('Noe gikk galt. Vennligst prøv igjen');
			},
			success: function (result) {
				$('.ajax-loader', result_wrapper).removeClass('active');
				if (result == '0') {
					result = 'Ingen artikler';
					$('.loadmore', result_wrapper).fadeOut(100);
				}
				if (args.append == false) {
					$('.results', result_wrapper).html(result);
					$filters.attr('data-page', 2);
				} else {
					$('.results', result_wrapper).append(result);
					$filters.attr('data-page', parseInt($filters.attr('data-page')) + 1);
				}

				// hide load more if there's nothing more to load. Duh!
				mydata.action = 'dc_have_more_posts';
				$.ajax({
					type: 'POST',
					url: ajaxurl,
					data: mydata,
					error: function () {
						$('.loadmore', result_wrapper).fadeOut(100);
					},
					success: function (result) {
						var articlesOnNextPage = parseInt(result);
						if (articlesOnNextPage <= 0) $('.loadmore', result_wrapper).fadeOut(200);
						else $('.loadmore', result_wrapper).fadeIn(200);
					},
				});
			},
		});
	}
}

function remembertab() {
	$('.child-tab-link').on('click', function () {
		var anchor = $(this).attr('href').replace('#', '?fane=');
		var newURL = window.location.pathname + anchor;

		window.history.replaceState({}, document.title, newURL);
	});

	// $('.accordion-title').on('click', function() {
	// 	var anchor = $(this).attr('id').replace('#', '?acrdn=');
	// 	var newURL = window.location.hash + anchor;

	// 	window.history.replaceState( {} , document.title, newURL);
	// });

	$('.accordion-title').on('click', function () {
		var anchor = $(this).attr('href').replace('#', '');
		var newURL = window.location.hash + anchor;

		setGetParameter('trekk', anchor);
	});
}

function setGetParameter(paramName, paramValue) {
	var url = window.location.href;
	var hash = location.hash;
	url = url.replace(hash, '');
	if (url.indexOf(paramName + '=') >= 0) {
		var prefix = url.substring(0, url.indexOf(paramName));
		var suffix = url.substring(url.indexOf(paramName));
		suffix = suffix.substring(suffix.indexOf('=') + 1);
		suffix = suffix.indexOf('&') >= 0 ? suffix.substring(suffix.indexOf('&')) : '';
		url = prefix + paramName + '=' + paramValue + suffix;
	} else {
		if (url.indexOf('?') < 0) url += '?' + paramName + '=' + paramValue;
		else url += '&' + paramName + '=' + paramValue;
	}

	url = decodeURI(url);
	// console.log(url);
	window.history.replaceState({}, document.title, url);
}

function getURLParameter(url, name) {
	return (RegExp(name + '=' + '(.+?)(&|$)').exec(url) || [, null])[1];
}

function openRememberedTab() {
	var url = window.location;

	if (getURLParameter(url, 'fane')) {
		var tabToFind = getURLParameter(url, 'fane');

		$('.child-tab-link').removeClass('active');
		$('.child-tab').hide();

		$('.child-tabs-content')
			.find('#' + tabToFind)
			.fadeIn();
		$('.child-tabs-header')
			.find($('a[href="#' + tabToFind + '"]'))
			.addClass('active');

		setTimeout(function () {
			scroll_there('#' + tabToFind);
		}, 100);

		// console.log('scroll to fane' + tabToFind);
	}
	if (getURLParameter(url, 'trekk')) {
		var tabToFind = getURLParameter(url, 'trekk');

		$('.accordion-item').removeClass('is-active');
		$('a[href="#' + tabToFind + '"]')
			.parent('li')
			.addClass('is-active');

		$('.accordion-item #' + tabToFind).slideDown();

		setTimeout(function () {
			scroll_there('#' + tabToFind + '-label');
		}, 100);

		var culturaSubtabOpenedOnLoadEvent = new CustomEvent('cultura-subtab-opened-on-load', {
			detail: {
				trekk: tabToFind
			}
		});
		window.dispatchEvent(culturaSubtabOpenedOnLoadEvent);
		// console.log('scroll to trekk' + tabToFind);
	}
}

function youtube_embed_overlap_fix() {
	var thereisaniframeonthepage = 0;
	$('iframe').each(function () {
		thereisaniframeonthepage = 1;
		var url = $(this).attr('src');
		var title = $(this).attr('title');
		var $this = $(this);

		if (thereisaniframeonthepage && !wordInString(title, 'AddThis')) {
			if (typeof url !== 'undefined' && url.indexOf('?') > 0) {
				$this.attr({
					src: url + '&wmode=transparent',
					wmode: 'opaque',
				});
			} else {
				$this.attr({
					src: url + '?wmode=transparent',
					wmode: 'opaque',
				});
			}
			thereisaniframeonthepage = 0;
		}
	});
}

function wordInString(s, word) {
	return new RegExp('\\b' + word + '\\b', 'i').test(s);
}

function analytics_events() {
	// Privat - Søk om lån
	$('#wpcf7-f973-o1 .thesubmit').on('click', function () {
		ga('send', 'event', 'Skjema', 'Klikket send', 'Privat - Søk om lån');
	});
	// Bedrift - Søk om lån
	$('#wpcf7-f3627-o1 .thesubmit').on('click', function () {
		ga('send', 'event', 'Skjema', 'Klikket send', 'Bedrift - Søk om lån');
	});
	// Privat - Bli kunde
	$('#wpcf7-f965-p5736-o1 .thesubmit').on('click', function () {
		ga('send', 'event', 'Skjema', 'Klikket send', 'Privat - Bli kunde PUM');
	});
	// Bedrift - Bli kunde
	$('#wpcf7-f972-p376-o1 .thesubmit').on('click', function () {
		ga('send', 'event', 'Skjema', 'Klikket send', 'Bedrift - Bli kunde');
	});
	// Bli medeier
	$('#wpcf7-f5123-p289-o1 .thesubmit').on('click', function () {
		ga('send', 'event', 'Skjema', 'Klikket send', 'Bli medeier');
	});
	// Spørsmål og svar Bli medeier
	$('#wpcf7-f5123-o1 .thesubmit').on('click', function () {
		ga('send', 'event', 'Skjema', 'Klikket send', 'Spørsmål og svar - Bli medeier');
	});
	// Kontakt oss
	$('#wpcf7-f174-o1 .thesubmit').on('click', function () {
		ga('send', 'event', 'Skjema', 'Klikket send', 'Kontakt oss skjema');
	});
	// Kontaktet om Boliglån
	$('#wpcf7-f5574-o1 .thesubmit').on('click', function () {
		ga('send', 'event', 'Skjema', 'Klikket send', 'Kontaktet om boliglån skjema');
	});
	// Kontaktet om Miljøboliglån
	$('#wpcf7-f5573-o2 .thesubmit').on('click', function () {
		ga('send', 'event', 'Skjema', 'Klikket send', 'Kontaktet om miljøboliglån skjema');
	});
	//Bli privatkunde - "Har bankid" button
	$('#harbankid').on('click', function () {
		ga('send', 'event', 'Skjema', 'Klikket send', 'Privat - Bli kunde BankID');
	});
	//Nettbank button in header
	$('#netbank-toggle').on('click', function () {
		ga('send', 'event', 'Skjema', 'Klikket nettbank', 'Nettbank knapp i header');
	});
	//Nettbank button in menu
	$('#netbank-toggle-menu').on('click', function () {
		ga('send', 'event', 'Skjema', 'Klikket nettbank', 'Nettbank knapp i meny');
	});
}

function increase_fontsize() {
	$('#increase').on('click', function () {
		var fontSize = parseInt($('html').css('font-size'));
		fontSize = fontSize + 1 + 'px';
		$('html').css({ 'font-size': fontSize });
	});

	$('#decrease').on('click', function () {
		var fontSize = parseInt($('html').css('font-size'));
		fontSize = fontSize - 1 + 'px';
		$('html').css({ 'font-size': fontSize });
	});
}

function featured_slide() {
	if ($('#featured-slide').length) {
		$('#featured-slide').slick({
			slidesToShow: 1,
			// adaptiveHeight: true
			// // autoHeight: true,
			// navigation: true,
		});
		$('#featured-slide').find('figure').css('display', 'block');
	}
}

function contactForm() {
	$('.wpcf7-submit').on('click', function (e) {
		if (grecaptcha.getResponse() == '') {
			e.preventDefault();
			$('.wpcf7-response-output').html('Vennligst verifiser at du ikke er en robot.');
			$('.wpcf7-response-output').show();
			return false;
		} else {
			// console.log('true');
		}
	});
}

function snow() {
	if ($('.snow-wrapper').length) {
		var canvas = document.getElementById('snow');
		var ctx = canvas.getContext('2d');
		var W = 1000;
		var H = 200;
		canvas.width = W;
		canvas.height = H;
		var numberFlakes = 45;
		var flakes = [];
		for (var i = 0; i < numberFlakes; i++) {
			flakes.push({
				x: Math.random() * W,
				y: Math.random() * H,
				radius: Math.random() * 2 + 1,
			});
		}
		function drawFlakes() {
			ctx.clearRect(0, 0, W, H);
			ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
			ctx.beginPath();
			for (var i = 0; i < numberFlakes; i++) {
				var f = flakes[i];
				ctx.moveTo(f.x, f.y);
				ctx.arc(f.x, f.y, f.radius, 0, Math.PI * 2, true);
			}
			ctx.fill();
			moveFlakes();
		}
		var angle = 0;
		function moveFlakes() {
			angle += 0;
			for (var i = 0; i < numberFlakes; i++) {
				var f = flakes[i];
				f.y += Math.cos(angle) + 1 + f.radius / 2;
				f.x += Math.sin(angle) * 2;
				if (f.x > W + 5 || f.x < -5 || f.y > H) {
					if (i % 3 > 0) {
						flakes[i] = { x: Math.random() * W, y: -10, radius: f.radius };
					} else {
						if (Math.sin(angle) > 0) {
							flakes[i] = { x: -5, y: Math.random() * H, radius: f.radius };
						} else {
							flakes[i] = { x: W + 5, y: Math.random() * H, radius: f.radius };
						}
					}
				}
			}
		}
		function init() {
			drawFlakes();
		}
		setInterval(init, 60);
	}
}

function formDataAttr() {
	if ($('.child-tabs-header').length && $('.wpcf7-form').length) {
		var cfTitle = $('.child-tab-link.active').text();
		$('.thesubmit').attr('data-track', cfTitle);
		dataLayer = [
			{
				track: cfTitle,
			},
		];
	} else if (!$('.child-tabs-header').length && $('.wpcf7-form').length && $('h1').length) {
		var cfTitle = $('h1').text();
		$('.thesubmit').attr('data-track', cfTitle);
	} else if (!$('.child-tabs-header').length && $('.wpcf7-form').length && !$('h1').length) {
		var cfTitle = window.location.href;
		$('.thesubmit').attr('data-track', cfTitle);
	}
}
$('.child-tab-link').on('click', function () {
	setTimeout(function () {
		formDataAttr();
	}, 500);
});

function setCookie(key, value, expiry) {
	var expires = new Date();
	expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);
	document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
}

function getCookie(key) {
	var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
	return keyValue ? keyValue[2] : null;
}

function headerNotice() {
	if ($('.header-notice').length) {
		var notice = $('.header-notice');
		var id = parseInt(notice.data('notice-id'));

		if (parseInt(getCookie('notice-dismissed')) !== id) {
			notice.addClass('active');
		}

		$('#dismissNoticeMessage').on('click', function (e) {
			e.preventDefault();
			setCookie('notice-dismissed', id, '7'); //(key, value, expiry in days)
			notice.hide();
		});
	}
}

function ajaxSearchHeight() {
	var $resultBox = $('.searchwp-live-search-results'),
		offset = $resultBox.offset().top,
		vh = $(window).height(),
		newMax = vh - offset;

	var newMax;
	$resultBox.css('max-height', newMax - 30);
}

/**
 * When using the [cultura_search] shortcode, we want the searchwp results box
 * to be light themed. See _searchwp.scss for the styling.
 */
function searchBoxStyling() {
	function shortCodeSearchFocus() {
		document.body.classList.add('search-results-light');
	}

	document.querySelectorAll('#shortcode-search-form input').forEach(function (input) {
		input.addEventListener('focus', shortCodeSearchFocus);
	});
}

function investorRelationsTabs() {
	if (document.querySelector('.ir-hero'))
		document.querySelectorAll('.ir-hero .tab-btn').forEach(function (btn) {
			btn.addEventListener('click', function () {
				// Remove and add active class on buttons.
				document.querySelector('.ir-hero .tab-btn.active').classList.remove('active');
				btn.classList.add('active');

				// Hide all tabs
				document.querySelectorAll('.ir-tab-content').forEach(function (tab) {
					tab.style.display = 'none';
				});

				// Show active tab
				var activeTabId = '#' + btn.id + '-content';
				document.querySelector(activeTabId).style.display = 'block';
			});
		});
}

function frendeToggleCookieMessageVisibility(isVisible) {
	var $cookieMessages = document.querySelectorAll('.webshop-cookies-message');
	if ($cookieMessages) {
		$cookieMessages.forEach(function(cookieMessage) {
			cookieMessage.style.display = (isVisible) ? 'block' : 'none';
			cookieMessage.ariaHidden = !isVisible;
		});
	}
}
function frendeWebshopAndRelated() {
	var $insuranceTables = document.querySelectorAll('.insurance-coverage-table-wrapper');
	var $webshopWrapper = document.querySelector('body.page-template-webshop-frend #shop');
	if ($insuranceTables || $webshopWrapper) {
		window.addEventListener('CookiebotOnConsentReady', function () {
			var $webshopWrapper = document.querySelector('body.page-template-webshop-frend #shop');
			if ($webshopWrapper) {
				$webshopWrapper.classList.remove('loading');
			}
			if (Cookiebot.consented===true) {
				setTimeout(function() {
					var $cookieMessages = document.querySelectorAll('.webshop-cookies-message');
					if ($cookieMessages) {
						$cookieMessages.forEach(function(cookieMessage) {
							cookieMessage.style.display = 'none';
						});
					}
					var $insuranceTables = document.querySelectorAll('.insurance-coverage-table-wrapper');
					if ($insuranceTables) {
						$insuranceTables.forEach(function(table) {
							table.style.display = 'block';
							if (table.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.contains('is-active')) {
								loadInsuranceTable(table);
							}
						});
					}
				}, 500);
			} else {
				frendeToggleCookieMessageVisibility(true);
			}
		});
		window.addEventListener('CookiebotOnDialogDisplay', function() {
			var $webshopWrapper = document.querySelector('body.page-template-webshop-frend #shop');
			if ($webshopWrapper) {
				$webshopWrapper.classList.remove('loading');
			}
			frendeToggleCookieMessageVisibility(true);
		})
	}

	var loadInsuranceTable = function(wrapper) {
		if ( wrapper.classList.contains('loaded') ) return;
		if ( !Cookiebot.consent.statistics ) return;
		wrapper.classList.add('loaded');
		var iframeSrc = wrapper.dataset.iframeSrc;
		var ifrm = document.createElement("iframe");
		ifrm.setAttribute("src", iframeSrc);
		ifrm.style.width = "100%";
		ifrm.style.height = "100%";
		ifrm.style.border = "1px solid #cccccc";
		wrapper.appendChild(ifrm);
	};

	var $accordionTitles = document.querySelectorAll('.child-tab .accordion-title');
	if ($accordionTitles) {
		$accordionTitles.forEach(function(accordionTitle) {
			accordionTitle.addEventListener('click', function(e) {
				var insuranceTableWrappers = e.target.parentNode.querySelectorAll('.insurance-coverage-table-wrapper');
				if (insuranceTableWrappers) {
					insuranceTableWrappers.forEach(function(wrapper) {
						loadInsuranceTable(wrapper);
					});
				}
			});
		});
	}

	window.addEventListener('cultura-subtab-opened-on-load', function(e) {
		if ( typeof e.detail.trekk === 'undefined' ) return;
		var insuranceTableWrappers = document.querySelectorAll('#' + e.detail.trekk + ' .insurance-coverage-table-wrapper');
		if (insuranceTableWrappers) {
			insuranceTableWrappers.forEach(function(wrapper) {
				loadInsuranceTable(wrapper);
			});
		}
	});
	
	var $cookiebotLinks = document.querySelectorAll('.update-cookiebot-link');
	if ( $cookiebotLinks ) {
		$cookiebotLinks.forEach(function(link) {
			link.addEventListener( 'click', function(e) {
				e.preventDefault();
				Cookiebot.renew();
			});
		});
	}
}